// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"e814d1ca","820":"93392268","964":"134970b9"}[chunkId] + ".chunk.js";
};